module.exports = __webpack_public_path__ + "static/media/green_device.2afde1ea.svg";